import React, { useEffect, useState } from 'react'
import FormSkel from './FormSkel'
import fetchHook from '../../hooks/fetchMSSQL-hook'
import { NotificationManager } from 'react-notifications'

export default function EventForm({ handleSubmit, handleClose, eventData }) {
  const defaultData = {
    Code: "",
    Name: "",
    NotificationType: "Nie wyświetlaj",
    Description: "",
    DefaultNotificationLevelId: 8,
    IsEditable: true,
  };

  const LIMITS = {
  Code: 200,
  Name: 250,
  Description: 250,
  };

  const onSubmit = (evt) => {
  evt.preventDefault();

  if ((data.Code || "").length > LIMITS.Code) {
    throttledNotify(`Kod może mieć maksymalnie ${LIMITS.Code} znaków`);
    return;
  }
  if ((data.Name || "").length > LIMITS.Name) {
    throttledNotify(`Nazwa może mieć maksymalnie ${LIMITS.Name} znaków`);
    return;
  }
  if ((data.Description || "").length > LIMITS.Description) {
    throttledNotify(`Opis może mieć maksymalnie ${LIMITS.Description} znaków`);
    return;
  }

  handleSubmit(evt, data, setData);
  };


  const [initialData, setInitialData] = useState(eventData || defaultData);
  const [data, setData] = useState(eventData || defaultData);
  const [notificationTypes, setNotificationType] = useState([]);
  const [changed, setChanged] = useState(false);
  const [isAvailableToSave, setIsAvailableToSave] = useState(false);
  const [lastNotify, setLastNotify] = useState(0);
  const { fetchMssqlApi } = fetchHook();
  const [loadingNT, setLoadingNT] = useState(false);


  const throttledNotify = (msg) => {
    const now = Date.now();
    if (now - lastNotify > 1500) {
      NotificationManager.error(msg);
      setLastNotify(now);
    }
  };

  useEffect(() => {
    setInitialData(eventData || defaultData);
    setData(eventData || defaultData);
  }, [eventData]);

  const normalizeToArray = (res) => {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.recordset)) return res.recordset;
    if (Array.isArray(res?.recordsets?.[0])) return res.recordsets[0];
    if (Array.isArray(res?.rows)) return res.rows;
    if (Array.isArray(res?.data)) return res.data;
    return [];
  };
  useEffect(() => {
    let alive = true;

    setLoadingNT(true);

    fetchMssqlApi(
      "notification-types",
      {
        method: "GET",
        hideNotification: true,
      },
      (res) => {
        if (!alive) return;

        setNotificationType(normalizeToArray(res));
        setLoadingNT(false);
      },
      () => {
        if (!alive) return;

        setNotificationType([]);
        setLoadingNT(false);
      }
    );

    return () => {
      alive = false;
    };
  }, []);

  const handleChangeNT = (name) => {
    const list = Array.isArray(notificationTypes) ? notificationTypes : [];
    const NT = list.find((nt) => nt.Name === name);
    if (NT) {
      setData((prev) => ({
        ...prev,
        NotificationType: name,
        DefaultNotificationLevelId: NT.NotificationLevelId,
      }));
    } else {
      setData((prev) => ({ ...prev, NotificationType: name }));
    }
    setChanged(true);
  };

  useEffect(() => {
    const ok =
      (data.Code || "").trim() &&
      (data.Name || "").trim() &&
      (data.Description || "").trim();
    setIsAvailableToSave(Boolean(ok));
  }, [data]);

  return (
    <FormSkel
      disableSubmit={!isAvailableToSave || !changed}
      noFooter={data && data.IsEditable === false}
      handleClose={handleClose}
      data={data}
      disableClose={loadingNT}
      headerText={
        eventData
          ? data.IsEditable
            ? "Edytuj zdarzenie"
            : "Zdarzenie"
          : "Nowe zdarzenie"
      }
    >
      <form
        id="modal-form"
        onSubmit={onSubmit}
        onKeyDown={(evt) => evt.key === "Enter" && evt.preventDefault()}
      >
        <div>
          <label className="h6">Kod zdarzenia</label>
      <input
        disabled={data && data.IsEditable === false}
        className={`form-control ${!data.Code ? "invalid-input" : ""}`}
        value={data.Code}
        onChange={(evt) => {
          const value = evt.target.value;
          if (value.length > LIMITS.Code) {
            throttledNotify(`Kod może mieć maksymalnie ${LIMITS.Code} znaków`);
            return;
          }
          setChanged(true);
          setData((prev) => ({ ...prev, Code: value || "" }));
        }}
        onPaste={(e) => {
          const pasted = (e.clipboardData || window.clipboardData).getData('text') || '';
          const next = (data.Code || '') + pasted;
          if (next.length > LIMITS.Code) {
            e.preventDefault();
            throttledNotify(`Kod może mieć maksymalnie ${LIMITS.Code} znaków`);
          }
        }}
        onFocus={() => {
          setData((prev) => ({ ...prev, Code: "" }));
        }}
      />

        </div>

        <div className="mt-3">
          <label className="h6">Nazwa</label>
        <input
          disabled={data && data.IsEditable === false}
          className={`form-control ${!data.Name ? "invalid-input" : ""}`}
          value={data.Name}
          onChange={(evt) => {
            const value = evt.target.value;
            if (value.length > LIMITS.Name) {
              throttledNotify(`Nazwa może mieć maksymalnie ${LIMITS.Name} znaków`);
              return;
            }
            setChanged(true);
            setData((prev) => ({ ...prev, Name: value || "" }));
          }}
          onPaste={(e) => {
            const pasted = (e.clipboardData || window.clipboardData).getData('text') || '';
            const next = (data.Name || '') + pasted;
            if (next.length > LIMITS.Name) {
              e.preventDefault();
              throttledNotify(`Nazwa może mieć maksymalnie ${LIMITS.Name} znaków`);
            }
          }}
          onFocus={() => {
            setData((prev) => ({ ...prev, Name: "" }));
          }}
        />

        </div>

        <div className="mt-3">
          <label className="h6">Rodzaj powiadomienia</label>
          <input
            disabled={data && data.IsEditable === false}
            className="form-control"
            value={data.NotificationType || ""}
            onChange={(evt) => {
              handleChangeNT(evt.target.value);
            }}
            onFocus={() => {
              setData((prev) => ({
                ...prev,
                NotificationType: "",
                DefaultNotificationLevelId: null,
              }));
              setChanged(true);
            }}
            list="notification-type"
          />
          <datalist id="notification-type">
            {(Array.isArray(notificationTypes) ? notificationTypes : []).map(
              (type, idx) => (
                <option value={type.Name} key={idx} />
              )
            )}
          </datalist>
        </div>

        <div className="mt-3">
          <label className="h6">Opis</label>
      <textarea
        disabled={data && data.IsEditable === false}
        className={`form-control ${!data.Description ? "invalid-input" : ""}`}
        value={data.Description}
        rows={5}
        onChange={(evt) => {
          const value = evt.target.value;
          if (value.length > LIMITS.Description) {
            throttledNotify(`Opis może mieć maksymalnie ${LIMITS.Description} znaków`);
            return;
          }
          setChanged(true);
          setData((prev) => ({ ...prev, Description: value || "" }));
        }}
        onPaste={(e) => {
          const pasted = (e.clipboardData || window.clipboardData).getData('text') || '';
          const next = (data.Description || '') + pasted;
          if (next.length > LIMITS.Description) {
            e.preventDefault();
            throttledNotify(`Opis może mieć maksymalnie ${LIMITS.Description} znaków`);
          }
        }}
       />
      </div>
      </form>
    </FormSkel>
  );
}